import { useMemo } from 'react';

import { Table } from '@foradevelopment/fora-ui';
import { PayReportingTableRowViewModelOld } from '@fora-monorepo/employer-my-pages-common/types';

import { TableSortId } from '../../../common/types';
import { PayrollTableSortId, PayrollTableSortState } from './PayrollTableSortState';
import { TypedTFunction, useTypedTranslation } from '../../../i18n/i18n';
import { PayrollReportingTableRowOld } from './PayrollReportingTableRowOld';

type PayrollReportingTableProps = {
  payReportingTableData: PayReportingTableRowViewModelOld[];
  listIndices: number[];
  sortTable: (sortId: PayrollTableSortId) => void;
  sortState: PayrollTableSortState;
  showIconColumn: boolean;
  validateOnRender?: boolean;
};

export const PayrollReportingTableOld = ({
  payReportingTableData,
  listIndices,
  sortTable,
  sortState,
  showIconColumn,
  validateOnRender,
}: PayrollReportingTableProps) => {
  const { t } = useTypedTranslation();
  const sortableTableHeadCells = useMemo(() => getSortableTableHeadCells(t), [t]);
  return (
    <Table withBorderedRows>
      <Table.Head>
        <Table.HeadRow fullBorderColor={'petroleumGreen'}>
          {sortableTableHeadCells.map((cell, index) => {
            if (cell.id === TableSortId.InactiveOrFokParameterChoices && !showIconColumn) {
              return null;
            }
            return (
              <Table.HeadCell
                key={`${cell.id}-${index}`}
                sortId={cell.id}
                onToggle={sortTable as (id: string) => void}
                state={sortState[cell.id]}
                textAlign={cell.textAlign}
                width={cell.width}
              >
                {cell.name}
              </Table.HeadCell>
            );
          })}
        </Table.HeadRow>
      </Table.Head>
      <Table.Body>
        {listIndices.map((listIndex, mapIndex) => (
          <PayrollReportingTableRowOld
            validateOnRender={validateOnRender}
            payReportingTableData={payReportingTableData[listIndex]}
            key={`report-payroll-table-row-${listIndex}`}
            index={mapIndex}
            showIconColumn={showIconColumn}
          />
        ))}
      </Table.Body>
    </Table>
  );
};

const getSortableTableHeadCells = (
  t: TypedTFunction
): {
  name: string;
  id: PayrollTableSortId;
  textAlign?: 'right' | 'center' | 'left';
  width?: string;
}[] => [
  { name: '', id: TableSortId.InactiveOrFokParameterChoices },
  { name: t('table.manualReporting.columnPin'), id: TableSortId.EmployeeId },
  { name: t('form.addEmployee.firstNameLabel'), id: TableSortId.FirstName },
  { name: t('form.addEmployee.lastNameLabel'), id: TableSortId.LastName },
  { name: t('form.editEmployee.markupTitle'), id: TableSortId.Markup },
  {
    name: t('table.manualReporting.columnAttributablePay'),
    id: TableSortId.AttributablePay,
    textAlign: 'right',
  },
  {
    name: t('table.manualReporting.columnPayAmount'),
    id: TableSortId.PayAmount,
    width: '115px',
  },
];
